import { ANALYZE_FOR_ENTRY_COMPONENTS, ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

import { AuthRoutingModule } from './auth-routing.module';
import { COMPONENTS } from './components';
import { PAGES } from './pages';
import { AUTH_GUARDS } from './guards';
import { AUTH_SERVICES } from './services';
import { AUTH_PROVIDERS, AuthProvider, REDIRECT_URL, STORAGE } from './providers';

import { ForgotPasswordComponent, SignInComponent, SignUpComponent, VerificationComponent } from '~auth/components';
import {
  AO_AUTH_URL,
  AuthConfig,
  BASE_URL,
  PAYMENT_GATEWAY_URL,
  SSO_COOKIE_NAME,
  SSO_TOKEN_NAME,
  USE_COOKIE
} from '~auth/providers/auth.provider';


export function provideAuth(p: Type<AuthProvider>) {
  return {
    provide: AUTH_PROVIDERS,
    useClass: p,
    multi: true
  };
}

const USER_MODALS = [
  SignInComponent,
  SignUpComponent,
  ForgotPasswordComponent,
  VerificationComponent
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AuthRoutingModule,
    HttpClientModule
  ],
  declarations: [...COMPONENTS, ...PAGES],
  exports: [...COMPONENTS, ...PAGES]
})
export class AuthModule {
  static forRoot(providers: Provider[] = [], config: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        ...AUTH_SERVICES,
        ...AUTH_GUARDS,
        CookieService,
        ...providers,
        { provide: HTTP_INTERCEPTORS, useClass: config && config.interceptor, multi: true },
        { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: USER_MODALS, multi: true },
        { provide: STORAGE, useValue: localStorage },
        { provide: REDIRECT_URL, useValue: config && config.redirectUrl },
        { provide: SSO_TOKEN_NAME, useValue: config && config.token },
        { provide: SSO_COOKIE_NAME, useValue: config && config.cookie },
        { provide: AO_AUTH_URL, useValue: config && config.aoUrl },
        { provide: BASE_URL, useValue: config && config.baseUrl },
        { provide: PAYMENT_GATEWAY_URL, useValue: config && config.paymentGatewayUrl },
        { provide: USE_COOKIE, useValue: config && config.useCookie },
      ]
    };
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/auth.module.ts